var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlutenSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.238,
    height: 28.692,
    viewBox: "0 0 21.238 28.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#10ad7d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.764)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M893.111,310.818l-5.41,4.273V315a7.592,7.592,0,0,1-3.983-2.8,9.072,9.072,0,0,1-1.195-5.343,7.832,7.832,0,0,1,4.339,2.9,8.1,8.1,0,0,1,1.2,4.008h.008a8.1,8.1,0,0,1,1.2-4.008,7.859,7.859,0,0,1,4.339-2.9A9.815,9.815,0,0,1,893.111,310.818Z",
    transform: "translate(-882.493 -300.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M892.473,325.935a7.619,7.619,0,0,1-3.983,2.8v2.074h-.738V328.74a7.618,7.618,0,0,1-3.983-2.8,6.965,6.965,0,0,1-.979-2.381l2.315-1.825a6.506,6.506,0,0,1,1.809,1.767,6.862,6.862,0,0,1,.838,1.834v-2.8a8.484,8.484,0,0,1-2.265-1.1l3-2.373v.058c.008-.025.017-.058.025-.083l5.178-4.082a8.582,8.582,0,0,1-1.22,4.779,7.619,7.619,0,0,1-3.983,2.8v2.8a6.871,6.871,0,0,1,.838-1.834,7.86,7.86,0,0,1,4.34-2.9A9.064,9.064,0,0,1,892.473,325.935Z",
    transform: "translate(-882.544 -302.123)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M886.788,317.066l-3.12,2.464a9.116,9.116,0,0,1-1.145-5.26A7.912,7.912,0,0,1,886.788,317.066Z",
    transform: "translate(-882.493 -302.007)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M890.788,304.319a9.057,9.057,0,0,1-1.975,5.094,8.975,8.975,0,0,1-1.983-5.094,7.8,7.8,0,0,1,1.983-4.829A7.764,7.764,0,0,1,890.788,304.319Z",
    transform: "translate(-883.232 -299.49)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.807)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M877.375,324.818a.623.623,0,0,1-.388-1.11l19.994-15.88a.622.622,0,0,1,.774.975l-19.993,15.88A.625.625,0,0,1,877.375,324.818Z",
    transform: "translate(-876.752 -307.694)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlutenSelected);
export default __webpack_public_path__ + "static/media/glutenSelected.46a619edd4d97f3b0ca1ae766cdbfd21.svg";
export { ForwardRef as ReactComponent };